var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/badge.tsx";
import classNames from 'classnames';
import React from 'react';
/** Badge to display on a user's profile. */
const Badge = ({
  title,
  slug
}) => /*#__PURE__*/React.createElement("span", {
  "data-testid": "badge",
  className: classNames('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium text-white', {
    'bg-fuchsia-700': slug === 'patron',
    'bg-yellow-500': slug === 'donor',
    'bg-black': slug === 'admin',
    'bg-cyan-600': slug === 'moderator',
    'bg-gray-100 text-gray-900': slug === 'bot',
    'bg-white bg-opacity-75 text-gray-900': slug === 'opaque'
  }),
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 3
  }
}, title);
export default Badge;